import { useTranslation } from 'react-i18next';
import { XPBar } from '@puzzlemania/lobby';
import { ProfileHeader } from '@puzzlemania/ui';
import { progressionStore, xpRequiredForLevel } from '@puzzlemania/progression';
import { FEATURE_FLAG_KEYS, remoteConfigStore } from '@puzzlemania/remote-config';
import { usePlatformServices } from '../composition/PlatformServicesContext';

// Local fallback curve constants — WP-XP.3 moves these to remote-config
// (XP_CURVE_BASE/XP_CURVE_INCREMENT), matching every other tunable reward value.
const XP_CURVE_BASE = 100;
const XP_CURVE_INCREMENT = 50;

export function ProfileScreen() {
  const { t } = useTranslation();
  const platform = usePlatformServices();
  const xp = progressionStore((s) => s.xp);
  const level = progressionStore((s) => s.level);
  const xpToNext = xpRequiredForLevel(level, XP_CURVE_BASE, XP_CURVE_INCREMENT);
  // Reactive to a live RC refresh, matching GameGrid's/AppLayout's own flag-check pattern.
  const liveFlags = remoteConfigStore((s) => s.flags);
  const xpEnabled =
    liveFlags[FEATURE_FLAG_KEYS.XP_ENABLED] ??
    platform.remoteConfig.getBoolean(FEATURE_FLAG_KEYS.XP_ENABLED, true);

  return (
    <div className="screen screen--profile">
      <ProfileHeader displayName={t('profile.guest_name')} />
      {xpEnabled && <XPBar level={level} xp={xp} xpToNext={xpToNext} />}
      <section className="profile__achievements">
        <h2 className="profile__achievements-title">{t('profile.achievements.title')}</h2>
        <p className="profile__achievements-empty" data-testid="achievements-empty">
          {t('profile.achievements.empty')}
        </p>
      </section>
    </div>
  );
}
